// eslint-disable-next-line import/prefer-default-export
export const urls = {
  LOGIN_URL: '/oauth2/authorization/postId',
  LOGOUT_URL: '/postId/logout',
  USER_ACCOUNT_URL: '/postId/account',
};
